import type { ReportFilterKey, ReportOptionFilterKey } from '@chukua/common';

export const FILTER_LABELS: Record<ReportFilterKey, string> = {
  from: 'From',
  to: 'To',
  asOf: 'As of',
  customerId: 'Customer',
  truckId: 'Truck',
  driverId: 'Driver',
  originZone: 'Origin',
  destinationZone: 'Destination',
  currency: 'Currency',
};

const PICKER_FILTERS: readonly ReportOptionFilterKey[] = ['customerId', 'truckId', 'driverId', 'originZone', 'destinationZone', 'currency'];

/** The pickers the bar shows: only the filters this report declares, in the bar's fixed order. */
export function pickerFilters(declared: readonly ReportFilterKey[]): ReportOptionFilterKey[] {
  return PICKER_FILTERS.filter((filter) => declared.includes(filter));
}

/** Every filter and the search set to undefined: one `setQuery` that returns the screen to unfiltered. */
export const CLEARED_FILTERS = {
  from: undefined,
  to: undefined,
  asOf: undefined,
  customerId: undefined,
  truckId: undefined,
  driverId: undefined,
  originZone: undefined,
  destinationZone: undefined,
  currency: undefined,
  q: undefined,
};

/** `useListQuery`'s `isFiltered` sees search and multi-value filters; the dates are single values, so they are added here. */
export const isReportFiltered = (isListFiltered: boolean, query: { from?: string; to?: string; asOf?: string }) =>
  isListFiltered || Boolean(query.from || query.to || query.asOf);

export const hasPeriod = (declared: readonly ReportFilterKey[]) => declared.includes('from') || declared.includes('to');
export const hasAsOf = (declared: readonly ReportFilterKey[]) => declared.includes('asOf');
